import { countApiTemplate } from "./apis/count";
import { listApiTemplate } from "./apis/list";
import { collectionConstructorFactory } from "../collection/collectionConstructorFactory";
import deepFreeze from 'deep-freeze-strict';
import { createApiTemplate } from "./apis/create";
import { updateApiTemplate } from "./apis/update";
import { getApiTemplate } from "./apis/get";
import { deleteApiTemplate } from "./apis/delete";
import { prodListApiTemplate } from "./apis/version/prodList";
import { publishApiTemplate, prodCountApiTemplate, publishDeleteOpApiTemplate, deleteOpCountApiTemplate, deleteOpListApiTemplate, historyCountApiTemplate, historyListApiTemplate, rollbackApiTemplate, unpublishedListApiTemplate, getPublishStatusApiTemplate, publishedListApiTemplate, publishedCountTemplate, unpublishedCountTemplate } from "./apis/version/rowVersion";
/**
 * 列表模板
 * https://docs.qq.com/doc/DTFVtb0hUTmRWdHh4
 * 根据 无极管理台接口规范 进行制定
 */
export const listTemplate = deepFreeze({
  templateId: 'list',
  name: '列表',
  desc: '用于生成列表类型的一系列组件',
  apiTemplates: [listApiTemplate, countApiTemplate, createApiTemplate, updateApiTemplate, getApiTemplate, deleteApiTemplate, prodListApiTemplate, deleteOpListApiTemplate, historyListApiTemplate, unpublishedListApiTemplate, publishApiTemplate, publishDeleteOpApiTemplate, rollbackApiTemplate, getPublishStatusApiTemplate, prodCountApiTemplate, deleteOpCountApiTemplate, historyCountApiTemplate, publishedListApiTemplate, publishedCountTemplate, unpublishedCountTemplate],
  entity: {
    defaults: [{
      cgiName: 'list',
      path: [{
        id: 'data',
        type: 'fields'
      }, {
        type: 'items'
      }]
    }, {
      cgiName: 'create',
      path: [{
        id: 'data',
        type: 'fields'
      }]
    }, {
      cgiName: 'update',
      path: [{
        id: 'data',
        type: 'fields'
      }]
    }, {
      cgiName: 'get',
      path: [{
        id: 'data',
        type: 'fields'
      }]
    }]
  }
});
export const ListCollection = collectionConstructorFactory(listTemplate);
//# sourceMappingURL=List.js.map
